/**
 * @file routes/_app/settings/job-functions.tsx
 * @description 聘用職務字典維護頁。
 *
 * 此頁編輯的字典項會出現在「員工檔案 → 聘用職務」下拉選單。
 */

import { createFileRoute } from '@tanstack/react-router';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/job-functions')({
  component: JobFunctionsPage,
});

/** 聘用職務維護頁 */
function JobFunctionsPage() {
  return (
    <LookupAdminPage
      resource="job-functions"
      resourceLabel="聘用職務"
      description="維護「員工檔案 → 聘用職務」下拉選單的候選項（如稽核員 / 稽核組長 / 審議人員 / 技術專家）。"
      nameMaxLength={50}
    />
  );
}
